// config/apiConfig.js
import configData from './config.json';

class ApiConfig {
  constructor() {
    // Get environment (development, production, staging)
    this.environment = process.env.REACT_APP_ENV || 'development';



    // Get base URL for current environment
    this.baseUrl = configData[this.environment]?.apiBaseUrl || configData.development.apiBaseUrl;

    // Remove trailing slash if present
    this.baseUrl = this.baseUrl.replace(/\/$/, '');

    console.log(`API Config loaded for ${this.environment}: ${this.baseUrl}`);
  }

  // Simple method to get full API URL
  getUrl(endpoint) {
    // Ensure endpoint starts with /
    const cleanEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
    return `${this.baseUrl}${cleanEndpoint}`;
  }

  // Get base URL
  getBaseUrl() {
    return this.baseUrl;
  }
}

// Create and export singleton instance
const apiConfig = new ApiConfig();
export default apiConfig;